import FacetSearchStore from "@javascript/stores/facetSearchStore";
import FilterItem from "../lds/FilterItem";
import Icon from "../lds/Icon";

function FacetSearchCompanyWorkingOn({ data }) {
  const { name, id, type, value } = data;
  const selected = FacetSearchStore.data.affiliation.selected === id;
  const leadingContent = <Icon name="radio" filled={selected} />;

  const handleSelect = () => {
    const selectedList = {
      orgListId: id,
      name: name,
      listType: "public",
      orgCount: value,
    };

    // TODO: Ideally, we move doEventSearch() into a store action, and
    //       adjust how we determine if an option is selected or not,
    //       in order to *exactly* match what is in production.
    FacetSearchListActions.toggleList(selectedList, { skipTrigger: true });
    FacetSearchAffiliatedWithActions.affiliationSelected(id, {
      skipTrigger: true,
    });

    doEventSearch();
  };
  return (
    <FilterItem
      className="companies_working_on_entry"
      id={"a_" + id}
      label={name}
      leadingContent={leadingContent}
      onLeadingContentClick={handleSelect}
      leadingContentClassName={"a_" + id}
      selected={selected}
    />
  );
}

// Default export uses createReactClass so we can listen to FacetSearchStore
export default createReactClass({
  mixins: [
    Reflux.listenTo(FacetSearchStore, function (data) {
      return data.affiliation;
    }),
  ],
  render() {
    return <FacetSearchCompanyWorkingOn {...this.props} />;
  },
});
